<template>
  <div v-if="noTax && shouldHaveTax">
    <div class="row align-items-center justify-content-between">
      <div class="col-12">
        <div class="alert alert-info alert-dashboard">Je hebt nog geen inkomstenbelasting geüpload.</div>
        <p>Voordat je je arbeidsongeschikt kan melden hebben wij inzicht in je inkomstenbelasting nodig.</p>
        <p>Deze mag maximaal 2 jaar oud zijn en moet de meeste recente zijn.</p>
        <p>Wij vragen je dit aangezien je €1500,- of meer per maand uitgekeerd wilt krijgen.</p>
      </div>
      <div class="col-12">
        <div class="dropzone p-3 text-center">
          <p class="small font-italic">
            Sleep je bestand hier naar toe of <br>
          </p>
          <label class="btn btn-primary btn-sm" for="upload-tax">
            <span v-if="processing"><spinner :color="'#008fce'"></spinner> Uploaden</span>
            <span v-else>Selecteer een bestand</span>
          </label>
          <p class="small font-italic m-0">
            .jpg, .png of .pdf - max. 10MB
          </p>
          <input type="file" class="d-none custom-file-input" id="upload-tax" ref="tax" accept="image/*, application/pdf" @change="submit">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Spinner from 'vue-spinner-component/src/Spinner';

export default {
    components: {
        Spinner,
    },
    props: ['noTax', 'shouldHaveTax'],
    data() {
        return {
            processing: false,
        };
    },
    methods: {
        submit() {
            this.processing = true;

            let data = new FormData();
            let files = this.$refs.tax.files || this.$refs.tax.dataTransfer.files;
            data.append('tax', files[0]);

            this.axios
                .post('belasting-uploaden', data)
                .then(() => {
                    this.$notify({
                        group: 'base',
                        text: 'Je belastingopgave is ontvangen.',
                        type: 'alert-info',
                    });

                    this.$emit('update-no-tax', false)
                })
                .finally(() => {
                    this.processing = false;
            });
        },
    },
};

</script>



// WEBPACK FOOTER //
// resources/assets/components/BelastingUploaden.vue